import React, { useEffect, useState } from 'react';
import Module from '../../../../layout/Module';
import FilterButtonSubjects from '../Filter/Filter';
import useSubjects from '../../../../../hooks/subjects/useSubjects';
import { updateColumnTableCurriculum } from '../../../../../store/actions/datatable.actions';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import DataGrid from '../../../../table/DataGrid';
import TextLog from '../../../../text/TextLog';
import IconTooltipButton from '../../../../button/IconTooltipButton';
import TextNote from '../../../../text/TextNote';
import DialogAction from '../Dialog/Dialog';
import Preview from '../Preview/Preview';
import { updateSubjectPreview } from '../../../../../store/actions/subjects.actions';
import TextEllipsis from '../../../../text/TextEllipsis';
import TextNotAssigned from '../../../../text/TextNotAssigned';
import { getObjectCurriculumElementsDR } from '../../utils';
import { Checkbox, Typography } from '@mui/material';
import MenuButton from '../../../../button/MenuButton';
import ButtonStartIcon from '../../../../button/ButtonStartIcon';

const List = () => {
  const navigate = useNavigate();
  const { curriculumId } = useParams();
  const dispatch = useDispatch();
  const permissions = useSelector((state) => state?.session?.permissions?.subject || {});
  const preview = useSelector((state) => state?.subject?.preview || null);
  const existLinceseAssessment = useSelector((state) =>
    state?.tenant?.license?.find((license) => license.code === 'assessment')
  );

  const options = [
    {
      label: 'Batch Update curriculum elements',
      icon: 'edit',
      permissions: permissions?.['batch-actions']?.includes('update-curriculum-elements'),
      onClick: () => setShowDialog({ type: 'update-curriculum-elements', form: { _id: checkIds } })
    },
    {
      divider: true,
      label: 'Batch Delete',
      icon: 'trash-alt',
      permissions: permissions?.['batch-actions']?.includes('delete'),
      onClick: () => setShowDialog({ type: 'batch-delete', form: { _id: checkIds } })
    }
  ].filter((item) => item.permissions);

  const { isLoading, isLoadingList, getSubjects } = useSubjects();

  const list = useSelector((state) => (state?.subject ? state?.subject[curriculumId]?.list || [] : []));
  const totalList = useSelector((state) =>
    state?.subject ? state?.subject[curriculumId]?.totalList || 0 : 0
  );

  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {});
  const curriculumList = useSelector((state) => state?.assessment?.curriculum);

  const state = useSelector((state) => state?.filter?.subject);
  const skip = useSelector((state) => state?.datatable?.subject?.skip || 0);
  const rowsPerPage = useSelector((state) => state?.datatable?.subject?.rowsPerPage || 50);
  const columnsTable = useSelector((state) => state?.datatable?.subject?.[curriculumId] || []);

  const [showDialog, setShowDialog] = useState(null);
  const [checkIds, setCheckIds] = useState([]);
  const onSelectedAll = () => {
    if (checkIds.length === 0) {
      setCheckIds(list.map((row) => row._id));
    } else {
      setCheckIds([]);
    }
  };
  const onSelected = (id, checked) => {
    if (checked) {
      setCheckIds([...checkIds, id]);
    } else {
      setCheckIds(checkIds.filter((item) => item !== id));
    }
  };

  const onReset = () => {
    setShowDialog(null);
    setCheckIds([]);
  };
  useEffect(() => {
    getSubjects(curriculumId, skip, rowsPerPage, state?.filter);
  }, [curriculumId, rowsPerPage, skip, state, state?.filter]);

  useEffect(() => {
    const columns = [
      {
        label: 'Code',
        key: 'code',
        align: 'left',
        width: 50,
        show: true,
        hide: true,
        position: 1
      },
      { label: 'Name', key: 'name', align: 'left', width: 200, show: true, hide: true, position: 2 }
    ];

    if (existLinceseAssessment) {
      if (currentCurriculum) {
        const elements = {};
        // if (currentCurriculum.elementsStructure) {
        //   elements[currentCurriculum.elementsStructure?._id] = {
        //     label: currentCurriculum.elementsStructure?.name,
        //     key: currentCurriculum.elementsStructure?._id,
        //     show: true,
        //     caret: true,
        //     hide: true,
        //     position: 2,
        //     width: 100,
        //     className: 'text-nowrap'
        //   };

        //   const mapElements = (child) => {
        //     elements[child._id] = {
        //       label: child.name,
        //       key: child._id,
        //       show: true,
        //       caret: true,
        //       hide: true,
        //       position: Object.keys(elements).length + 2,
        //       width: 100,
        //       className: 'text-nowrap'
        //     };
        //     // child?.children?.forEach((element) => {
        //     //   mapElements(element);
        //     // });
        //   };

        //   currentCurriculum.elementsStructure?.children.forEach((child) => {
        //     mapElements(child);
        //   });
        // }

        // Nueva estructura para los subjects
        if (currentCurriculum.elementsStructure) {
          elements[currentCurriculum.elementsStructure?._id] = {
            label: currentCurriculum.elementsStructure?.name,
            key: 'elementId',
            show: true,
            caret: true,
            hide: true,
            position: 4,
            width: 100,
            className: 'text-nowrap'
          };

          const subElement = currentCurriculum.elementsStructure?.children[0];
          if (subElement) {
            elements[subElement?._id] = {
              label: subElement?.name,
              key: 'subElementId',
              show: true,
              caret: true,
              hide: true,
              position: 5,
              width: 100,
              className: 'text-nowrap'
            };
          }
        }

        Object.keys(elements).forEach((key) => {
          columns.push(elements[key]);
        });
      }

      if (['unassigned', 'assigned', 'all'].includes(curriculumId)) {
        columns.push({
          label: 'Curriculum',
          key: 'curriculum',
          align: 'left',
          width: 350,
          show: true,
          hide: true,
          position: 5
        });
      }
    }

    columns.sort((a, b) => a.position - b.position);
    dispatch(updateColumnTableCurriculum(currentCurriculum._id, 'subject', columns, true));
  }, [currentCurriculum]);

  const onRedirect = (id) => {
    navigate(`/dashboard/subjects/${curriculumId}/edit/${id}`);
  };

  return (
    <>
      <Module.BodyHeader className='border-b border-b-2 border-primary justify-between'>
        <FilterButtonSubjects />
        {checkIds.length > 1 &&
          (options.length > 1 ? (
            <MenuButton title='Actions' icon='ellipsis-v' color='primary' items={options} />
          ) : (
            <ButtonStartIcon
              icon={options[0]?.icon || 'cog'}
              children={options[0]?.label || 'Action'}
              startIcon={options[0]?.icon || 'cog'}
              color='primary'
              variant='contained'
              disabled={false}
              onClick={options[0]?.onClick}
            />
          ))}
      </Module.BodyHeader>
      <Module.BodyContainer>
        <DataGrid
          id='subjects'
          nameModule='subject'
          curriculumId={curriculumId}
          rows={list.map((row, index) => {
            const elements = {};
            const currentCurriculum2 = curriculumList.find((item) => item._id === row.curriculumId) || {};

            const elementsName = {};
            if (currentCurriculum2.elementsStructure) {
              elementsName[currentCurriculum2.elementsStructure?._id] = {
                label: currentCurriculum2.elementsStructure?.name,
                key: currentCurriculum2.elementsStructure?._id,
                description: ''
              };

              const mapElements = (child) => {
                elementsName[child._id] = {
                  label: child.name,
                  key: child._id,
                  description: ''
                };
                child?.children?.forEach((element) => {
                  mapElements(element);
                });
              };

              currentCurriculum2.elementsStructure?.children.forEach((child) => {
                mapElements(child);
              });
            }

            Object.keys(row.curriculumElements || {}).forEach((element) => {
              const mapElements = (key, value, children) => {
                const find = children?.find((child) => child._id === value.value);
                if (find) {
                  elements[key] = find.name?.length > 50 ? find.name.substring(0, 50) + '...' : find.name;
                  if (elementsName[key]) {
                    elementsName[key][`description`] = elements[key] || '';
                  }
                  Object.keys(value?.children || {}).forEach((child) => {
                    const el = find.elements?.find((c) => c.elementStructureId === child);
                    if (el) {
                      mapElements(child, value.children[child], el.children);
                    }
                  });
                }
              };

              mapElements(
                element,
                row.curriculumElements[element],
                currentCurriculum2.elements?.children || []
              );
            });

            // nueva estructura para los subjects
            const elementsc = getObjectCurriculumElementsDR(
              currentCurriculum2?.elements,
              currentCurriculum2?.elementsStructure,
              row?.curriculumelements || {}
            );

            return {
              ...row,
              index: index + 1 + rowsPerPage * skip,
              log: <TextLog updatedAt={row.updatedAt} updatedBy={row.updatedBy} />,
              description: <TextNote notes={row.description || ''} />,
              // ...elements,
              elementId: elementsc?.element?.valueName || '',
              subElementId: elementsc?.subElement?.valueName || '',
              curriculum: row?.curriculumId ? (
                <div className='max-w-350px'>
                  <TextEllipsis className='text-sm'>
                    {currentCurriculum2?.shortName} - {currentCurriculum2?.name}
                  </TextEllipsis>
                  {/* {Object.keys(elementsName)
                    .filter((key) => elementsName[key]?.description)
                    .map((key) => (
                    <div key={`element-name-${key}`} className='flex gap-1 items-center'>
                      <span className='text-xs font-bold text-nowrap'>{elementsName[key]?.label}:</span>
                      <TextEllipsis
                        className='text-xs'
                        title={elementsName[key]?.description || ''}
                      >
                        {elementsName[key]?.description || '-'}
                      </TextEllipsis>
                    </div>
                  ))}  */}
                  <div className='flex gap-1 items-center'>
                    <span className='text-xs font-bold text-nowrap'>{elementsc?.element?.keyName}</span>
                    <TextEllipsis className='text-xs'>{elementsc?.element?.valueName}</TextEllipsis>
                  </div>
                  <div className='flex gap-1 items-center'>
                    <span className='text-xs font-bold text-nowrap'>{elementsc?.subElement?.keyName}</span>
                    <TextEllipsis className='text-xs'>{elementsc?.subElement?.valueName}</TextEllipsis>
                  </div>
                </div>
              ) : (
                <TextNotAssigned />
              ),
              actions: (
                <div className='flex items-center gap-1 items-center justify-center'>
                  {permissions?.preview && (
                    <IconTooltipButton
                      id={`preview-${row._id}`}
                      disabled={isLoading}
                      title='Preview'
                      icon='expand-alt'
                      onClick={() => dispatch(updateSubjectPreview(row._id))}
                    />
                  )}
                  {permissions?.cloned && (
                    <IconTooltipButton
                      id={`clone-${row._id}`}
                      disabled={isLoading}
                      title='Clone'
                      icon='clone'
                      onClick={() => setShowDialog({ type: 'clone', form: row })}
                    />
                  )}
                  {permissions?.updated && (
                    <IconTooltipButton
                      id={`edit-${row._id}`}
                      disabled={isLoading}
                      title='Edit'
                      icon='pen'
                      onClick={() => onRedirect(row._id)}
                    />
                  )}
                  {permissions.archived && (
                    <IconTooltipButton
                      id={`archive-${row._id}`}
                      disabled={isLoading}
                      title='Archive'
                      icon='archive'
                      onClick={() => setShowDialog({ type: 'archive', form: row })}
                    />
                  )}
                  {permissions.deleted && (
                    <IconTooltipButton
                      id={`delete-${row._id}`}
                      disabled={isLoading}
                      title='Delete'
                      icon='trash-alt'
                      onClick={() => setShowDialog({ type: 'delete', form: row })}
                    />
                  )}
                </div>
              ),

              checkIds: (
                <Checkbox
                  id={`checkbox-id-user-${row._id}`}
                  checked={checkIds.includes(row._id)}
                  onChange={(e) => onSelected(row._id, e.target.checked)}
                  color='primary'
                />
              )
            };
          })}
          loading={isLoadingList}
          totalRows={totalList}
          skip={skip}
          rowsPerPage={rowsPerPage}
          actionsSetting={
            checkIds.length > 0 && (
              <Typography className='min-w-100px' align='right'>
                Rows selected {checkIds.length}
              </Typography>
            )
          }
          columns={[
            { label: '#', key: 'index', align: 'center', width: 10, show: true, hide: false },
            {
              show: permissions['batch-actions'],
              key: 'checkIds',
              align: 'center',
              width: 15,
              label: (
                <Checkbox
                  id={`checkbox-id-user-header`}
                  checked={checkIds.length > 0 && checkIds.length === list.length}
                  indeterminate={checkIds.length > 0 && checkIds.length < list.length}
                  onChange={(e) => onSelectedAll(e.target.checked)}
                  color='primary'
                />
              )
            },
            ...columnsTable,
            {
              label: 'Description',
              key: 'description',
              align: 'center',
              width: 200,
              show: true,
              hide: false
            },
            { label: 'Log', key: 'log', align: 'center', width: 120, show: true, hide: false },
            { label: 'Actions', key: 'actions', align: 'center', width: 50, show: true, hide: false }
          ]}
          labelNoRows="You don't have any subjects yet"
        />
        {showDialog && (
          <DialogAction
            show={!!showDialog}
            onClose={() => setShowDialog(null)}
            type={showDialog.type}
            formData={showDialog.form}
            onReset={onReset}
          />
        )}
        {preview && <Preview />}
      </Module.BodyContainer>
    </>
  );
};

export default List;
